export default __webpack_public_path__ + "static/icon-e353bccdfb1c6359081daa36393805fb.png";